module.exports = __webpack_public_path__ + "static/media/30OIOS2.05262abd.jpg";